import React, { useState } from 'react';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

interface TooltipProps {
  text: string;
}

const Tooltip: React.FC<TooltipProps> = ({ text }) => {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <span className="relative ml-1 inline-block">
      <QuestionMarkCircleIcon
        className="h-4 w-4 text-gray-400 inline cursor-pointer"
        onMouseEnter={() => setIsVisible(true)}
        onMouseLeave={() => setIsVisible(false)}
      />
      {isVisible && (
        <div className="absolute z-50 w-64 px-3 py-2 text-xs text-white bg-gray-800 rounded-md shadow-lg bottom-full mb-2 left-1/2 transform -translate-x-1/2 whitespace-normal">

          {text}
          <div className="absolute w-2 h-2 bg-gray-800 transform rotate-45 -bottom-1 left-32"></div>
        </div>
      )}
    </span>
  );
};

export default Tooltip;
